<template>
  <div class="page">
    <TopTab>
      <div class="title">大咖课程管理平台</div>
    </TopTab>
    <div class="container">
      <router-view></router-view>
    </div>
    <BottomFooter></BottomFooter>
  </div>
</template>
<script>
import TopTab from '@/components/TopTab'
import BottomFooter from '@/components/BottomFooter'

export default {
  name: 'CoursePage',
  components: { TopTab, BottomFooter },
  data() {
    return {}
  },
  created() {
    const dispatch = this.$store.dispatch

    // 刷新用户基础信息
    dispatch('user/getUserInfo')
    // 刷新用户权限列表
    dispatch('right/getAllRightList')
  }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/style/variable/index.scss';

.page {
  min-height: 101vh;
  display: flex;
  flex-direction: column;
}

.container {
  flex: auto;
  width: $page-width;
  margin: 100px auto 0;
}

.title {
  flex: auto;
  padding-left: 66px;
  font-size: 18px;
  color: #ffffff;
}
</style>
